import { Link } from "react-router-dom";
import { useUser } from "../store";
import { toSlug } from "common";
import { BreadCrumbs } from "./BreadCrumbs";
import "./Payers.scss";

export const Payers = () => {
  const { user, group, facility } = useUser();
  const payers = user?.facilitiesPayers?.[facility] ?? [];

  return (
    <>
      <BreadCrumbs
        path={[group, facility]}
        labels={["My Facilities", facility]}
      />
      <main className="content payers-page">
        <header className="payers-heading">
          <div>
            <span className="payers-eyebrow">Facility</span>
            <h1 className="capitalize">{facility}</h1>
            <p>Select a payer to review its aging reports.</p>
          </div>
          <span className="payers-count">
            <strong>{payers.length}</strong>
            {payers.length === 1 ? " payer" : " payers"}
          </span>
        </header>

        {payers.length ? (
          <nav className="payers-grid" aria-label={`Payers for ${facility}`}>
            {payers.map((payer) => (
              <Link
                key={payer}
                to={`/${toSlug(user.group)}/${toSlug(facility)}/${toSlug(payer)}`}
                className="payer-card"
              >
                <span className="payer-card-icon" aria-hidden="true">
                  <i className="fa-solid fa-file-invoice-dollar" />
                </span>
                <span className="payer-card-name uppercase">{payer}</span>
                <span className="payer-card-description">View aging reports</span>
                <i className="fa-solid fa-arrow-right payer-card-arrow" aria-hidden="true" />
              </Link>
            ))}
          </nav>
        ) : (
          <section className="payers-empty-state">
            <span className="payer-card-icon" aria-hidden="true">
              <i className="fa-solid fa-file-invoice-dollar" />
            </span>
            <h2>No payers available</h2>
            <p>There are no payers assigned to this facility yet.</p>
          </section>
        )}
      </main>
    </>
  );
};
